<ng-container *ngIf="HasCriteria">
    <div *ngFor="let criterion of aggregateCriterias">
        <custom-view *ngIf="isCustomView(criterion)" [component]="getCustomView(criterion)" [customDataBinding]="getBindingObject(criterion)">
        </custom-view>

        <standard-task *ngIf="!isCustomView(criterion)" [aggregateCriteria]="criterion">
        </standard-task>
    </div>
</ng-container>

<ng-container *ngIf="!HasCriteria">
    <div *ngFor="let criterion of Aggregates">
        <custom-view *ngIf="isCustomView(criterion)" [component]="getCustomView(criterion)" [customDataBinding]="getBindingObject(criterion)">
        </custom-view>

        <standard-task *ngIf="!isCustomView(criterion)" [aggregate]="criterion">
        </standard-task>
    </div>
</ng-container>

<div *ngIf="showMore" fxLayout="column" fxLayoutAlign="center center">
    <forge-icon-button (click)="handleShowMore($event)" dense aria-label="Show more">
        <forge-tooltip>Show more</forge-tooltip>
        <forge-icon name="chevron_double_down"></forge-icon>
    </forge-icon-button>
    <forge-divider style="width: 100%;"></forge-divider>
</div>
